<template>
  <common-page-table
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="$t('GetCatalogUnit статистика детальная')"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :keyTable="'receiverSystemCode'"
    :deleteParams="()=>{}"
    :apiDeleteName="apiDeleteName"
    :alternativeConverter="convertData"
    :isDefaultConverter="false"
    :force-delete="false"
    :force-is-create="false"
    :force-is-edit="false"
    :prefixShow="prefixShow"
    :hasReadOnlyInTable="hasReadOnlyInTable"
    :eventGetParamsGetData="true"
    :trigerReinit="trigerReinit"
    @setTriger="setTriger"
    :forceIsSearch="false"
    :hasAction="false"
    @setAllParams="event=>allParamsApi=event"
  >
    <div>
      <div class="col-sm-12">
        <FilterBlockStatistic :filter-list="filterList" :filterData="filterData" :defaultDataIn="defaultDataIn" />
      </div>

      <div class="col-sm-4">
        <l-button type="info" class="smallBtn" wide block @click="load()">{{
            $t("Скачать")
          }}
        </l-button>
      </div>

    </div>
  </common-page-table>
</template>
<script>
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageTable from "../../commonElement/CommonPageTable.vue";
import { API_METHODS, GLOBAL_DATE_TIME_FORMAT } from "../../../../constant";
import convertLangDataToTable from "../../../../helpers/converters/convertLangDataToTable";
import FilterBlockStatistic from "../statisticHrFeed/FilterBlockStatistic.vue";
import { nextTick } from 'vue'
import {ApiService} from "@/util/ApiService";
export default {
  name: "StatisticGetCatalogUnitTable",
  components: { CommonPageTable, FilterBlockStatistic },
  props: {
    hasReadOnlyInTable: { type: Boolean, default: true },
    routeField: { type: String, default: "CompanyId" }
  },
  data() {
    return {
      allParamsApi: null,
      defaultDataIn: null,
      trigerReinit: false,
      dateFrom: "",
      dateTo: "",
      fieldLang: "",
      apiName: API_METHODS.GET_STATISTIC_GetCatalogUnit,
      apiDeleteName: "",
      filterList: [{
        "code": "dateFrom",
        "name": "Период от",
        "type": "Date",
        "refEntityCode": null,
        "colWidth": 6,
        "subListId": 0,
        "watchAttr": null
      },
        {
          "code": "dateTo",
          "name": "До",
          "type": "Date",
          "refEntityCode": null,
          "colWidth": 6,
          "subListId": 0,
          "watchAttr": null
        }
      ]
    };
  },
  created() {
    const { dateFrom, dateTo } = this.$route.params
    this.dateFrom = this.$moment(dateFrom).format("YYYY-MM-DD");
    this.dateTo = this.$moment(dateTo).format("YYYY-MM-DD");
    this.defaultDataIn = {
      dateFrom :this.dateFrom,
      dateTo: this.dateTo
    }
  },
  computed: {
    paramsGetData() {
      const { receiverSystemCode } = this.$route.params
      return {
        paramsDop: {
          receiverSystemCode,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        }
      };
    },
    prefixEdit() {
      return `/statisticGetCatalogUnit`;
    },
    prefixShow() {
      return this.prefixEdit;
    },
    linkCreate() {
      return this.prefixEdit + "/create";
    },
    nameRoleEntity() {
      let role = NAME_OBJECT.StatisticGetCatalogUnit;
      return role;
    }
  },
  methods: {
    async load() {
      console.log(this.$route.params)
      const { receiverSystemCode } = this.$route.params
      const response = await ApiService(API_METHODS.GET_LOAD_STATISTIC, {
        ...this.allParamsApi,
        receiverSystemCode
      });
      const blob = new Blob([response.data]
      );

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const fileName =  decodeURIComponent( response.headers['filename']) || 'report.xlsx';

      link.download = fileName;
      link.click()
    },
    setTriger(){
      this.trigerReinit = false;
    },
    convertData(dataNow, langNow) {
      let res = convertLangDataToTable(dataNow, langNow, "", false);
      res = res.map(el => {
        return {
          ...el,
          dateCreated: this.$moment(el.dateCreated).format(
            GLOBAL_DATE_TIME_FORMAT
          )
        };
      });
      return res;
    },
     filterData(val) {
      if(this.dateFrom == val.dateFrom && this.dateTo == val.dateTo) {
        this.trigerReinit = true;
      } else {
        this.dateFrom = val.dateFrom;
        this.dateTo = val.dateTo;
      }
    }
  }
};
</script>
